<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-07-18 03:09:24
 * @LastEditTime: 2026-07-10 09:54:54
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 原物料共享推送
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\material\approvalForm.vue
-->
<template>
  <div>
    <el-dialog :visible.sync="dialog" width="1140px" :close-on-click-modal="false" :before-close="resetForm">
      <span slot="title" class="dialog-title">采购结算单</span>
      <div>
        <el-form ref="form" :rules="rules" :model="formVal" label-width="100px" :inline="true" label-position="right">
          <el-form-item label-width="80px" prop="mianBodyName">
            <span slot="label">供应商:</span>
            <span>{{ params.supplier }}</span>
          </el-form-item>
          <el-form-item label-width="100px" prop="mianBodyName">
            <span slot="label">合同签订主体:</span>
            <span>{{ params.contractSigningSubject }}</span>
          </el-form-item>
          <el-form-item label-width="100px" prop="mianBodyName">
            <span slot="label">结算时间段:</span>
            <span>{{ params.startTime }}至{{ params.endTime }}</span>
          </el-form-item>
          <el-form-item label-width="100px" prop="mianBodyName">
            <span slot="label">结算单编号:</span>
            <span>{{ params.statementNo }}</span>
          </el-form-item>
          <el-form-item label-width="80px" prop="applayName">
            <span slot="label">申请人:</span>
            <span v-if="!formVal.applayName" style="color: forestgreen;width: 200px;" @click="openAccount">请选择申请人</span>
            <span v-else style="color: forestgreen;" @click="openAccount">
              <el-input v-model="formVal.applayName" style="color: forestgreen;width: 250px;"></el-input>
            </span>
          </el-form-item>
          <div>

            <el-form-item label-width="80px" prop="businessCategory">
              <span slot="label">业务大类:</span>
              <el-select v-model="formVal.businessCategory" placeholder="请选择" filterable clearable style="width:100%">
                <el-option v-for="item in businessBigTypeList" :key="item.operationTypeCode"
                  :label="item.operationTypeName" :value="item.operationTypeName"
                  @click.native="setSmallName(item)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="paperAttachments">
              <span slot="label">纸质附件</span>
              <el-select ref="selection" v-model="formVal.paperAttachments" style="width: 200px">
                <el-option :key="0" label="无" :value="0"></el-option>
                <el-option :key="1" label="有" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label-width="80px" prop="businessSmallType">
              <span slot="label">业务小类</span>
              <el-select v-model="formVal.businessSmallType" placeholder="请选择" filterable clearable style="width:100%">
                <el-option v-for="item in businessTypeList" :key="item.operationSubTypeCode"
                  :label="item.operationSubTypeName" :value="item.operationSubTypeName"
                  @click.native="setBusinessName(item)"></el-option>
              </el-select>
            </el-form-item> -->
          </div>
          <!-- <div>
            <el-form-item prop="abstractMession">
              <span slot="label">摘要</span>
              <el-input v-model="formVal.abstractMession" style="width:520px" type="textarea" :rows="1"
                placeholder="请填写处">
              </el-input>
            </el-form-item>
          </div> -->
          <div>
            <el-form-item prop="mattersNotes">
              <span slot="label">摘要</span>
              <el-input v-model="formVal.mattersNotes" style="width:520px" type="textarea" :rows="2" placeholder="请填写处">
              </el-input>
            </el-form-item>
          </div>
          <div class="dialoginfo">
            采购结算单：
            <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe show-overflow-tooltip
              style="width: 100%" :data="formVal.details" tooltip-effect="dark" :span-method="arraySpanMethod">
              <template v-for="(item, index) in table">
                <el-table-column v-if="item" :key="index" :prop="item.prop" :label="item.label" :width="item.width"
                  align="center" :show-overflow-tooltip="item.label == '共享状态' ? false : true">
                  <template slot-scope="scope">
                    <span v-if="item.label == '供应商'">
                      <el-select v-model="scope.row.shareSupplierCode" placeholder="请选择" filterable clearable
                        style="width:100%">
                        <el-option v-for="item in collaborativeUnitList" :key="item.shareSupplierCode"
                          :label="item.shareSupplierName" :value="item.shareSupplierCode"
                          @click.native="setshareSupplier(item, scope.$index)"></el-option>
                      </el-select>
                    </span>
                    <span v-else-if="item.label == '业务类型'">
                      <el-select :key="'businessType' + scope.$index" v-model="scope.row.businessType" placeholder="请选择"
                        filterable clearable style="width:100%">
                        <el-option v-for="item in businessTypeList" :key="item.operationSubTypeCode"
                          :label="item.operationSubTypeName" :value="item.operationSubTypeName"
                          @click.native="setBusinessName(item, scope.$index)"></el-option>
                      </el-select>
                    </span>
                    <span v-else-if="item.label == '结算不含税金额（元）'">
                      <el-input :key="'notIncludeTaxMoney' + scope.$index" v-model="scope.row.notIncludeTaxMoney"
                        type="number" style="width:100%" placeholder="请输入"></el-input>
                    </span>
                    <span v-else-if="item.label == '附件'">
                      <el-button class="bottom_one" size="mini" @click="upFile(scope.$index)">上传附件</el-button>
                    </span>
                    <span v-else-if="item.label == '过程节点'">
                      <el-select v-model="scope.row.processNodesCode" placeholder="请选择">
                        <el-option label="过程结算" value="001" @click.native="scope.row.processNodes = '过程结算'"></el-option>
                        <el-option label="最终结算" value="002" @click.native="scope.row.processNodes = '最终结算'"></el-option>
                        <el-option label="质保金到期" value="003" @click.native="scope.row.processNodes = '质保金到期'"></el-option>
                      </el-select>
                    </span>
                    <span v-else-if="item.label == '共享状态'">
                      <el-popover placement="top-start" title="" width="200" trigger="hover"
                        :content="scope.row.shareResponse">
                        <span v-if="scope.row.shareStatus == 1" slot="reference">提交共享成功</span>
                        <span v-if="scope.row.shareStatus == 2" slot="reference">提交共享失败</span>
                        <span v-if="scope.row.shareStatus == 3" slot="reference">共享审核完成</span>
                        <span v-if="scope.row.shareStatus == 4" slot="reference">共享审核驳回</span>
                      </el-popover>

                    </span>
                    <span v-else-if="item.label == '协作单位'">
                      {{ scope.row.detailCollaborativeList ? scope.row.detailCollaborativeList.map(item =>
                        item.collaborativeUnits).join(',') : '' }}
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetForm">关 闭</el-button>
        <el-button :disabled="isSave" class="bottom_all" @click="submitForm">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 上传附件 -->
    <el-dialog v-dialogDrag :visible.sync="uploadFileDig" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">上传附件</span>
      <div v-loading="loading" element-loading-text="上传中..." element-loading-background="rgba(0, 0, 0, 0.8)"
        class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag
          action="/resource/resources/upload" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
          <div slot="tip" class="el-upload__tip" style="color:red">*{{ upload_tip }}</div>
        </el-upload>
        <div style="margin:10px;font-size:18px">
          <!-- <div style="text-align: left;">
            已上传文件:
            <div v-for="(item, index) in formVal.details[lowindex].files" :key="index">
              <el-link type="sucess" :underline="false" @click="lookFile(item.url)">{{
                item.name }}</el-link> <el-link v-if="item.name != '采购结算单-截图'" type="danger" style="margin-left: 24px;"
                :underline="false" @click="deleteFile(index)">删除</el-link>
            </div>
          </div> -->
            <div style="text-align: left;">
            已上传文件:
            <div v-for="(item, index) in formVal.details[lowindex].files" :key="index">
              <el-link type="sucess" :underline="false" @click="lookFile(item.url)">{{
                item.name }}</el-link> <el-link v-if="item.name != '采购结算单-截图'" type="danger" style="margin-left: 24px;"
                :underline="false" @click="deleteFile(index)">删除</el-link>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="uploadFileDig = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 截图数据 -->
    <div style="position: fixed; top: -10000px;left:10000px;overflow:hidden;">
      <tableMain id="approvalFormTableMain" :ref="`approvalFormTableMain`" :key="`approvalFormTableMain`"
        :tableData="imgTableData" :isImg="true" />
    </div>
    <!-- 核算主体 -->
    <AccountTable ref="accountTable" :dialog.sync="accountDialog" @resetAccount="resetAccount" @setAccount="setAccount" />
  </div>
</template>
<script>
import { cardLogin_HX, getUserList_HX, getProject_HX, updateGXCostState } from "@/views/ShareSystem/api/mainHx.js";
import { UPLOAD_TIP } from "@/utils/utils";
import { getToken } from "@/utils/auth";
import { materialQueryDetail, pushShare, queryCollaborativeUnitList } from "@/api/docking.js";
import {
  getCategory
} from "@/views/ShareSystem/api/mainHx.js";
import html2canvas from 'html2canvas';
import AccountTable from "./accountTable.vue";
import { uploadFile } from "@/api/common.js";
import { _debounce } from '@/utils/utils.js'
import tableMain from "./tableMain.vue";
// import { alterContractProfitCenter, } from "@/api/contractManageApi";
export default {
  components: {
    AccountTable,
    tableMain
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    params: {},
  },
  data() {
    return {
      tableParams: {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
        status: 1,//只查询启用状态
      },
      accessToken: "",
      total: 0,
      // userData: [],
      projectHxList: [],
      businessBigList: [
        { id: "HSYW227", name: "库存商品出库" },
      ],
      businessSmallList: [
        { id: "HSYW227001", name: "自制库存商品-结转主营业务成本" },
        { id: "HSYW227002", name: "外购库存商品结转主营业务成本" },
      ],
      businessBigTypeList: [],
      rules: {
        applayName: [{ required: true, message: "请选择事由", trigger: "change" }],
        sharedProductName: [{ required: true, message: "请选择事由", trigger: "change" }],
        paperAttachments: [{ required: true, message: "请选择事由", trigger: "change" }],
      },
      formVal: {
        // accountMainBody:"",
        mianBodyId: "",
        mianBodyName: "",
        businessTime: "",
        paperAttachments: 0,
        applayName: "",
        sharedProductCode: "",
        sharedProductName: "",
        businessType: "",
        operationTypeCode: "",
        businessSmallType: "",
        incomeType: "",
        remark: "",
        attachment: "",
        pictureAttachment: "",
        details: [
          { files: [], }
        ],
      },
      tableDataChild: [
      ],
      tableHeadChild: [],
      oldAmount: 0,
      table: [
        { label: "共享状态", width: "150px", prop: "", status: true },
        { label: "共享编码", width: "150px", prop: "shareProjectCode", status: true },
        { label: "供应商", width: "150px", prop: "shareSupplierName", status: true },
        { label: "合同编码", width: "150px", prop: "shareContractCode", status: true },
        { label: "项目", width: "auto", prop: "shareProjectCode", status: true },
        { label: "税率", width: "150", prop: "taxRate", status: true },
        { label: "过程节点", width: "150", prop: "processNodes", status: true },
        { label: "附件", width: "150", prop: "resion", status: true },
        { label: "结算金额（元）", width: "150", prop: "settleMoneyIncludeTax", status: true },
        { label: "业务类型", width: "150", prop: "resion", status: true },
        { label: "结算不含税金额（元）", width: "150", prop: "notIncludeTaxMoney", status: true },
        { label: "协作单位", width: "150", prop: "resion", status: true },
      ],
      businessTypeList: [],
      lowindex: 0,
      fileArr: [],
      uploadFileDig: false,
      upload_tip: UPLOAD_TIP,
      upheader: {},
      loading: false,
      files: [],
      filesPush: [],
      tableDataOver: false,
      isSave: false,
      accountDialog: false,
      collaborativeUnitList: [],
      imgTableData: [],
    }
  },
  watch: {

  },
  created() {
    this.upheader = {
      "access-token": getToken(),
    };
  },
  methods: {
    addItem(index) {
      let obj = JSON.parse(JSON.stringify(this.formVal.details[index]))
      obj.notIncludeTaxMoney = ''
      obj.businessType = ''
      obj.businessTypeCode = ''
      obj.id = ''
      obj.code = ''
      this.formVal.details.splice(index + 1, 0, obj);
    },
    delItem(index) {
      if (this.formVal.details.length > 1) {
        this.formVal.details.splice(index, 1);
      }
    },
    deleteFile(index) {
      this.formVal.details[this.lowindex].files.splice(index, 1);
    },
    deleteFile1(index) {
      this.files.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        url: 'https://lvshe.huashijc.com/file/' + data.fileUrl,
      };
      const params1 = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params1);
      this.filesPush.push(params);
    },
    lookFile(imgUrl) {
      window.open(imgUrl, "_blank");
    },
    filebefore(file) {
      this.loading = true;
      const allowedFormats = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png',];
      const isAllowedFormat = allowedFormats.includes(file.type);
      if (!isAllowedFormat) {
        this.$message.error("数据上传必须是  pdf, jpeg, jpg, png,格式!");
        this.loading = false;
      }
      return isAllowedFormat;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code === 1001) {
        this.formVal.details[this.lowindex].files.push({
          name: res.data.fileName,
          url: 'https://lvshe.huashijc.com/file/' + res.data.fileUrl
        })
      }
    },
    upFile(index) {
      this.lowindex = index
      this.uploadFileDig = true
    },
    changeFileName() {
      this.tableDataChild.forEach(item => {
        item.files[0].name = item.businessSmallType
      })
    },
    async initData() {
      console.log("this.params----------------------------------")
      console.log(this.params)
      this.formVal = this.$options.data().formVal
      let that = this
      let res = await cardLogin_HX({ idCard: "icps" })
      if (res.code == 1001) {
        let info = res.data;
        if (info && info.accessToken) {
          that.accessToken = info.accessToken
          // this.getUserList(that.accessToken);
          // this.getProject_HX(that.accessToken);
          this.getBusinessSingle(that.params);
          this.getCategory();
          this.getCategory('制造-销售收入', true)
          // this.$emit("openDialog");
        }
      }
    },
    queryCollaborativeUnitList() {
      queryCollaborativeUnitList({ id: this.params.id }).then((res) => {
        if (res.code == 1001) {
          this.collaborativeUnitList = res.data
          // this.formVal.details.forEach(item => {
          //   item['detailCollaborativeList'] = this.collaborativeUnitList.find(item2 => item2.shareSupplierCode == item.shareSupplierCode).detailCollaborativeList
          //   item['rawStatementDetailList'] = this.collaborativeUnitList.find(item2 => item2.shareSupplierCode == item.shareSupplierCode).rawStatementDetailList
          // });
          this.formVal.details.forEach(item => {
            // 先安全地查找匹配项
            const matchItem = this.collaborativeUnitList.find(item2 => item2.shareSupplierCode == item.shareSupplierCode);
            // 如果找到了，才赋值；找不到就给个空数组兜底
            if (matchItem) {
              item['detailCollaborativeList'] = matchItem.detailCollaborativeList || [];
              item['rawStatementDetailList'] = matchItem.rawStatementDetailList || [];
            } else {
              item['detailCollaborativeList'] = [];
              item['rawStatementDetailList'] = [];
            }
          });
          this.fetchAllDataAndGenerateImg(this.formVal.details);
        }
      })
    },
    restParams() {
      this.tableParams = {
        page: 1,
        pageSize: 10,
        code: "",
        name: "",
      }
      this.initData();
    },
    arraySpanMethod({ row, rowIndex, columnIndex }) {
      // 需要合并的列索引（第1、5、6列）
      const mergeCols = [0, 1, 2, 3, 4, 5, 6, 7, 8];
      if (!mergeCols.includes(columnIndex)) {
        return [1, 1]; // 不合并
      }

      // 只有当列是需要合并的列时才处理
      const data = this.formVal.details;
      const currentDataType = row.shareSupplierCode;

      // 如果是第一行，计算连续相同 shareSupplierCode 的行数
      if (rowIndex === 0) {
        let rowspan = 1;
        for (let i = 1; i < data.length; i++) {
          if (data[i].shareSupplierCode === currentDataType) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      } else {
        // 非第一行，判断上一行 shareSupplierCode 是否相同
        if (data[rowIndex - 1].shareSupplierCode === currentDataType) {
          // 与上一行相同，隐藏当前单元格
          return [0, 0];
        } else {
          // 不同，计算连续相同 shareSupplierCode 的行数
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].shareSupplierCode === currentDataType) {
              rowspan++;
            } else {
              break;
            }
          }
          return [rowspan, 1];
        }
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // let num = 0
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 2) {
          const values = data.map(item => Number(item["totalAmount"]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = '';
          }
        }
        if (index === 3) {
          sums[index] = this.oldAmount;
          return;
        }
      });
      return sums;
    },
    setshareSupplier(data, index) {
      this.formVal.details[index].shareSupplierName = data.shareSupplierName
    },
    setBusinessName(data, index) {
      this.formVal.details[index].businessTypeCode = data.operationSubTypeCode
    },
    setSmallName(data) {
      this.formVal.businessCategoryCode = data.operationTypeCode
      this.getCategory(data.operationTypeName, true)
    },
    openSupplyDetail(index) {
      this.lowindex = index
      this.detailSupplyDialog = true
      this.$refs.detailSupply.initData();
    },
    getProject_HX(accessToken) {
      if (!accessToken) {
        this.$message.error('accessToken获取为空～')
        return;
      } else {
        getProject_HX({ page: 1, pageSize: 100 }, accessToken).then((res) => {
          this.projectHxList = res.data?.data;
        });
      }
    },
    getUserList(accessToken) {
      getUserList_HX(accessToken).then((res) => {
        this.userData = res.data;
        console.log(this.userData)
      });
    },
    getCategory(operationTypeName, isSmall) {
      let param = {
        page: 1,
        pageSize: 9999,
        operationTypeName: operationTypeName,
      }
      getCategory(param, this.accessToken).then(res => {
        if (res.code == 1001) {
          if (isSmall) {
            this.businessTypeList = res.data.records[0].mainDictGxBusinessList
          } else {
            this.businessBigTypeList = res.data.records;
          }

        }
      });
    },

    getBusinessSingle(data) {
      let params = {
        rawStatementId: data.id
      }
      this.oldAmount = 0
      materialQueryDetail(params).then((res2) => {
        if (res2.code == 1001) {
          if (res2.data) {
            this.formVal = res2.data
            this.formVal.paperAttachments = this.formVal.paperAttachments || 1
            if (!this.formVal.businessType) {
              this.formVal.businessCategory = '制造-销售收入'
              this.formVal.businessCategoryCode = 'HSSR410'
            }
            if (!this.formVal.mattersNotes) {
              let nowDate = new Date().Format('yyyy年MM月')
              if (data.contractSigningSubjectId == '22876753760489472') {
                this.formVal.mattersNotes = `默认入账到${nowDate}，建材公司为简易计税，进项税转出。`
              } else {
                this.formVal.mattersNotes = `默认入账到${nowDate}`
              }
            }
            // this.formVal.details.forEach(item => {
            //   item['files'] = item.attachment ? JSON.parse(item.attachment) : []
            //   if (item.shareStatus !== 1 || item.shareStatus !== 3) {
            //     item.files = item.files.filter(item => item.name !== '采购结算单-截图')
            //   }
            // })
            // 增加安全判断：确保 details 存在且是一个数组
            if (this.formVal.details && this.formVal.details.length > 0) {
              this.formVal.details.forEach(item => {
                item['files'] = item.attachment ? JSON.parse(item.attachment) : []
                if (item.shareStatus !== 1 || item.shareStatus !== 3) { 
                  item.files = item.files.filter(fileItem => fileItem.name !== '采购结算单-截图')
                }
              })
            } else {
              // 如果后端返回的 details 为空，则赋予默认结构，防止渲染报错
              this.$set(this.formVal, 'details', [{ files: [] }]);
            }
            this.queryCollaborativeUnitList();


          }
        } else {
          this.$emit("mainLoadingClose");

        }
      }).catch(() => {
        this.$emit("mainLoadingClose");
      });
    },
    async fetchAllDataAndGenerateImg(imgData) {
      console.log(imgData)
      for (let engIndex = 0; engIndex < imgData.length; engIndex++) {
        console.log('------for-----')
        if(imgData[engIndex].shareStatus !==1 ||imgData[engIndex].shareStatus !==3) {
          this.imgTableData = imgData[engIndex].rawStatementDetailList,
          // 等待 generateImg 完成后再继续下一次循环
          await this.generateImg(engIndex);
        }
       
      }
      console.log('------------截图完成------------')
      console.log(this.formVal)
      this.$emit("openDialog");

    },

    async generateImg(index) {
      await this.$nextTick();

      return new Promise((resolve, reject) => {
        const tableRef = this.$refs[`approvalFormTableMain`];
        if (!tableRef || !tableRef.$el) {
          return reject(new Error(`未找到 ref approvalFormTableMain`));
        }
        const table = tableRef.$el;
        let bodyWrapper = document.querySelector("#imgTable .el-table__body-wrapper");
        let headerNode = document.querySelector("#imgTable .el-table__header-wrapper");
        let footerNode = document.querySelector("#imgTable .el-table__footer-wrapper");
        let imgTable = document.querySelector("#imgTable");
        //设置新高度
        bodyWrapper.style.height = `${bodyWrapper.scrollHeight}px`;
        bodyWrapper.style.width = `${bodyWrapper.scrollWidth + 100}px`;
        document.getElementById("approvalFormTableMain").style.width = `${bodyWrapper.scrollWidth}px`;
        document.getElementById("approvalFormTableMain").style.height = `${bodyWrapper.scrollHeight + headerNode.scrollHeight + footerNode.scrollHeight}px`;
        imgTable.setAttribute('style', `height: ${bodyWrapper.scrollHeight + headerNode.scrollHeight + footerNode.scrollHeight}px;`);
        const rect = table.getBoundingClientRect();
        html2canvas(table, {
          width: rect.width,
          height: rect.height,
          scrollX: -window.scrollX,
          scrollY: -window.scrollY,
          scale: window.devicePixelRatio || 1,
        }).then(canvas => {
          canvas.toBlob(blob => {
            if (!blob) {
              return reject(new Error('canvas.toBlob 返回了 null'));
            }
            const file = new File([blob], "采购结算单-截图.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);

            uploadFile(params).then(res => {
              if (res.code === 1001) {
                res.data.fileUrl = 'https://lvshe.huashijc.com/file/' + res.data.fileUrl;
                let obj = {
                  name: res.data.fileName,
                  url: res.data.fileUrl
                }
                this.formVal.details[index].files.push(obj)
                resolve(res.data);
              } else {
                this.$emit("mainLoadingClose");
                reject(new Error('上传失败，code=' + res.code));
              }
            }).catch(err => {
              this.$emit("mainLoadingClose")
              reject(err)
            }

            );
          });
        }).catch(err => {
          this.$emit("mainLoadingClose")
          reject(err)
        }
        );
      });
    },

    openAccount() {
      this.accountDialog = true
      this.$refs.accountTable.initData();
    },
    resetAccount() {
      this.accountDialog = false
    },
    setAccount(row) {
      // this.formVal.accountMainBody = row.deptName
      // this.formVal.applayName = row.deptName
      this.formVal.applayName = row.deptName
      this.formVal.leCode = row.deptCode
      this.formVal.employeeCode = row.foreignId
      this.formVal.postId = row.positionCode
    },
    resetForm() {
      this.formVal = this.$options.data().formVal
      this.$emit("resetForm");
    },
    //月报量-保存
    submitForm: _debounce(function () {
      if (!this.formVal.applayName) {
        this.$message.warning('请选择申请人!')
        return
      }
      if (!this.formVal.paperAttachments && this.formVal.paperAttachments != 0) {
        this.$message.warning('请选择纸质附件!')
        return
      }
      this.isSave = true
      this.formVal.details = this.formVal.details.filter(item => ![1, 3].includes(item.shareStatus))
      this.formVal.details.forEach(item => {
        item.attachment = JSON.stringify(item.files)
        item.originalDocumentsUrl = `https://lvshe.huashijc.com/#/materialSettleDetail_HX?code=`
      })
      pushShare(this.formVal).then((res) => {
        if (res.code == 1001) {
          this.isSave = false
          this.$message.success(res.codeMsg)
          this.resetForm();
        }
        this.isSave = false
      }).catch(() => {
        this.isSave = false
      });

    }, 500),
    updateGXCostState() {
      let param = {
        endTime: this.params.endTime,
        startTime: this.params.startTime,
        lisiTime: this.params.lisiTime,
        settleMonth: this.params.settleMonth,
        companyId: this.params.secondId,
        checkStatus: 0,
        gxStatus: 0
      }
      updateGXCostState(param).then(res => {
        if (res.code == 1001) {
          let dataContent = {
            params: param,
            settlementStartTime: param.startTime,
            settlementEndTime: param.endTime,
            periodSettlement: [param.startTime, param.endTime]
          }
          const query = {
            type: 1,
            taskName: "业务记账单审批表",
            taskStatus: 0,
            taskType: 1,
            dataContent: JSON.stringify(dataContent)
          };
          this.$router.push({ name: 'submitBusinessBilling', query: query })
        }
      }).catch(() => {
        // this.$message.warning(r) 
      })
    },
    sizeChange(value) {
      this.tableParams.pageSize = value;
      this.initData();
    },
  }
}
</script>
<style lang="scss" scoped>
.addClass {
  display: flex;
  justify-content: end;
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

::v-deep .el-table__body tr.current-row>td {
  color: #fff;
  background: #00b85c !important;
}
</style>